<div
fxLayout="row"
fxLayout.lt-sm="column"
fxLayoutAlign="center center"
style="background-color: rgb(255, 255, 255);"
>
<div
  fxFlex="30"
  fxLayout="column"
  fxFlex.lt-md="100"
  fxLayoutAlign="center center"
>
  <div>
    <h1>Registrate</h1>
  </div>
  <div>
    <h2>Subtitulo</h2>
  </div>
  <div>
    <p>Parrafo 1</p>
  </div>

  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <input matInput placeholder="Aqui un texto" />
    </mat-form-field>
    <button mat-flat-button color="primary" style="width: 100%">Registrarme</button>
  </div>
</div>

<div
  fxFlex="70"
  fxFill
  fxLayout="column"
  fxLayoutAlign="center center"
  fxShow.lt-md="false"
>
  <img
    src="../../assets/images/toreaBay.jpg"
  style="width: 100%; height: 100vh; "
  />
</div>
</div>